import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { FileText, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const normalizarAcao = (acao: string): string =>
    (acao || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

const detectaOrientacaoPreviaEditada = (acao: string): boolean => {
    const texto = normalizarAcao(acao);

    if (texto.includes("orientacoes completas alteradas")) {
        return false;
    }

    return (
        texto.includes("editou orientacao previa") ||
        texto.includes("orientacoes previas alteradas") ||
        (texto.includes("editou orientacao") && texto.includes("previa"))
    );
};

const getIconOrientacaoPreviaEditada = (_acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: FileText, color: "var(--c8e44ad)" };
};

export default function CardOrientacaoPreviaEditada({
    item,
    onNavigateToFile,
    isExpanded,
    onToggleExpand
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconOrientacaoPreviaEditada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const orientacaoPreviaEditadaConfig = {
    tipo: "orientacao_previa_editada",
    detectaTipo: detectaOrientacaoPreviaEditada,
    getIcon: getIconOrientacaoPreviaEditada,
    temExpansao: () => true,
    Component: CardOrientacaoPreviaEditada
};


